import { Edit, Delete } from "@mui/icons-material";
import React from "react";
import { Tooltip, IconButton, Typography, Switch } from "@mui/material";
import {
  setOperadoresId,
  setDefaultDataOperadores,
} from "store/modules/Operadores";
import { v4 as uuidv4 } from "uuid";
import { modifyOperadores } from "./functions";
import { modifyOperadorActive } from "components-base/pedidos/functions";

const cancelOperador = async (e, data, dispatch, setRefresh, refresh) => {
  data.activo = !data.activo;
  await modifyOperadorActive(data, dispatch);
  setRefresh(!refresh);
};

export const columns = (
  setOpen,
  setMode,
  setOpenDelete,
  dispatch,
  refresh,
  setRefresh
) => {
  return [
    {
      field: `${uuidv4()}`,
      headerName: "Acciones",
      width: 150,
      renderCell: (data) => (
        <React.Fragment>
          <Tooltip title={data.row.activo ? "Desactivar Operador" : "Activar Operador"} placement="top">
            <Switch
              color="primary"
              checked={data.row.activo}
              onChange={(e) =>
                cancelOperador(e, data.row, dispatch, setRefresh, refresh)
              }
              inputProps={{ "aria-label": "controlled" }}
            />
          </Tooltip>
          <Tooltip title="Editar operador" placement="top">
            <IconButton
              aria-label="edit"
              color="primary"
              onClick={() => {
                setOpen(true);
                setMode("PUT");
                dispatch(setDefaultDataOperadores(data.row));
                dispatch(setOperadoresId(data.row.id));
              }}
            >
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar Operadores" placement="top">
            <IconButton
              aria-label="delete"
              color="primary"
              onClick={() => {
                setOpenDelete(true);
                setMode("DELETE");
                dispatch(setOperadoresId(data.row.id));
              }}
            >
              <Delete />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      ),
    },
    {
      field: "codigo",
      headerName: "Código",
      width: 200,
    },
    {
      field: "nombre",
      headerName: "Nombre",
      width: 250,
      renderCell: (data) => (
        <Typography>
          {`${data.row.persona.nombre} ${data.row.persona.apellidoPaterno} ${data.row.persona.apellidoMaterno} `}{" "}
        </Typography>
      ),
    },
    {
      field: "rfc",
      headerName: "RFC",
      width: 250,
      renderCell: (data) => (
        <Typography>{`${data.row.persona.rfc}`} </Typography>
      ),
    },
    {
      field: "tipoLicencia",
      headerName: "Tipo Licencia",
      width: 200,
    },
    {
      field: "vigenciaLicencia",
      headerName: "Vigencia Licencia",
      width: 200,
    },
    {
      field: "direccion",
      headerName: "Dirección",
      width: 350,
      renderCell: (data) => (
        <Typography>{`${data.row.persona.direccion}`} </Typography>
      ),
    },
  ];
};
